type MetadataFieldType = "STRING" | "FLOAT" | "NUMBER" | "BOOLEAN"

interface MetadataFieldResult {
  metadata_field_type: MetadataFieldType
  metadata_field_key: string
  metadata_field_value: string | number
}

interface MetadataFieldOutputSource {
  result?: Record<string, unknown> | null
  result_json?: Record<string, unknown> | null
}

const METADATA_FIELD_TYPES: ReadonlySet<string> = new Set([
  "STRING",
  "FLOAT",
  "NUMBER",
  "BOOLEAN",
])

function parseMetadataFieldResult(
  value: Record<string, unknown> | null | undefined,
): MetadataFieldResult | undefined {
  if (!value) {
    return undefined
  }

  const fieldType = value.metadata_field_type
  const fieldKey = value.metadata_field_key
  const fieldValue = value.metadata_field_value

  if (
    typeof fieldType !== "string" ||
    !METADATA_FIELD_TYPES.has(fieldType) ||
    typeof fieldKey !== "string" ||
    fieldKey.length === 0
  ) {
    return undefined
  }

  const hasExpectedValueType =
    (fieldType === "STRING" && typeof fieldValue === "string") ||
    (fieldType !== "STRING" &&
      typeof fieldValue === "number" &&
      Number.isFinite(fieldValue) &&
      (fieldType !== "BOOLEAN" || fieldValue === 0 || fieldValue === 1))

  if (!hasExpectedValueType) {
    return undefined
  }

  return {
    metadata_field_type: fieldType as MetadataFieldType,
    metadata_field_key: fieldKey,
    metadata_field_value: fieldValue,
  }
}

export function getMetadataFieldResult(
  metricOutput: MetadataFieldOutputSource,
): MetadataFieldResult | undefined {
  return (
    parseMetadataFieldResult(metricOutput.result) ??
    parseMetadataFieldResult(metricOutput.result_json)
  )
}
